import { Button, Card, Group, Stack, Title } from '@mantine/core';
import { PurchasedCourses } from './PurchasedCourses';
import { AvailableCourses } from './AvailableCourses';
import { MasterProgress } from './MasterProgress';
import { useNavigate } from 'react-router-dom';

export function CourseSection() {
  const navigate = useNavigate();
  return (
    <Stack gap='xs'>
      <Card shadow='sm' withBorder radius='sm'>
        <Group justify='space-between'>
          <Title order={3}>Corsi</Title>
          <Button onClick={() => navigate('/proCourses')}>
            Consulta tutti i corsi
          </Button>
        </Group>
      </Card>
      <PurchasedCourses />
      <AvailableCourses />
      <MasterProgress />
    </Stack>
  );
}
